import axios from 'axios';
import { z } from 'zod';

import { strictQuery } from 'utils/strict-query';

import { CreateOriginatorOptionsZod } from 'types/zod/create-originator-options';
import { NewParticipantZod } from 'types/zod/new-participant';

const OriginatorApi = {
    addOriginator: strictQuery({
        In: z.object({ originator: NewParticipantZod, options: CreateOriginatorOptionsZod.optional() }),
        Out: z.object({ password: z.string(), originator_id: z.number() }),
        handler: ({ originator, options }) => axios.post('/participants/originators', originator, { params: options }),
    }),
};

export default OriginatorApi;
